import { createStore, getActionIds } from '../helpers/redux';
import Immutable from 'immutable';
import { OrganizationActions } from '../actions/organization';
import { AccountActions } from '../actions/account';

const actions = getActionIds(OrganizationActions);
const accountActions = getActionIds(AccountActions);
const initialState = Immutable.fromJS({
  organizations: {},
  users: {},
  currentOrganizationId: null,
});

export const organizations = createStore(initialState, {
  [actions.getOrganizations.success]: (state, action) =>
    state.mergeDeep({
      organizations: action.result.entities.organizations,
    }),

  [actions.setOrganizationId]: (state, action) =>
    state.mergeDeep({
      currentOrganizationId: action.organizationId,
    }),

  [actions.getOrganization.success]: (state, action) =>
    state.mergeDeep({
      organizations: action.result.entities.organizations,
    }),

  [actions.createOrganization.success]: (state, action) =>
    state.mergeDeep({
      organizations: action.result.entities.organizations,
    }),

  [accountActions.createAccount.success]: (state, action) => {
    const organizationId = action.args[0].organizationId;
    return state.mergeDeep({
      organizations: {
        [organizationId]: {
          accounts: state.getIn(['organizations', organizationId, 'accounts'])
                    .push(action.result.result),
        },
      },
    });
  },

  [accountActions.getAccounts.success]: (state, action) => {
    const organizationId = action.result.organizationId;
    return state.mergeDeep({
      organizations: { [organizationId]: { accounts: action.result.result.result } },
    });
  },

  [actions.addUser.success]: (state, action) => {
    const x = (action.result.entities.users) ? state.mergeDeep({
      users: action.result.entities.users,
    }) : state;
    // console.log('x', x, state, action);
    return x;
  },

  [actions.removeUser.success]: (state, action) =>
    state.deleteIn(['users', action.args[1]]),

  [actions.getOrganizationUsers.begin]: (state) => state.set('users', Immutable.fromJS({})),

  [actions.getOrganizationUsers.success]: (state, action) => {
    if (!action.result.entities.users) return state;
    const results = Immutable.fromJS(action.result.entities.users);
    return state.set('users', results);
  },

  [actions.changeUserRole.success]: (state, action) =>
    state.mergeDeep({
      users: { [action.args[1]]: { role: action.args[2] } },
    }),

  [actions.deleteOrganization.success]: (state, action) => {
    const organizationId = action.args[0].toString();
    return state.deleteIn(['organizations', organizationId]);
  },

  [actions.renameOrganization.success]: (state, action) =>
    state.mergeDeep({
      organizations: action.result.entities.organizations,
    }),

});

export const currentOrganizationIdSelector = (state) =>
  state.organizations.get('currentOrganizationId');



// WEBPACK FOOTER //
// ./src/reducers/organizations.js